import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import { Skeleton } from "@mui/material";
import * as Styles from "./styles";
import ProductCard from "./components/ProductCard";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Espelho from "./components/Espelho";

interface ProductSelectProps {
  value: string;
  label: string;
  codigoSap: string;
}

interface SelectProps {
  value: string;
  label: string;
}

interface DataProps {
  bandeira: SelectProps;
  bloco: SelectProps;
  produto: ProductSelectProps;
  blocosData: any[];
}

interface Props {
  onClose: () => void;
  data: DataProps;
  idLead: string | undefined;
  openOpportunityForm: () => void;
}

const EspelhoVendasModal: React.FC<Props> = (props) => {
  const { data: dataEspelhoVenda, refetch: refetchEspelhoVendas } =
    useEspelhoVendas({
      queryKey: "espelho_vendas",
      codigoSap: props?.data?.produto?.codigoSap,
      nomeBloco: props?.data?.bloco?.label,
    });
  const [zoomLevel, setZoomLevel] = useState<number>(0.7);
  const [buttonState, setButtonState] = useState<boolean>(true);
  const exibirEmpreendimento =
    dataEspelhoVenda?.data?.resumos?.resumoBloco?.exibirEmpreendimento;

  useEffect(() => {
    refetchEspelhoVendas();
  }, []);

  const handleZoomIn = () => {
    setZoomLevel((prevZoomLevel) => Math.min(prevZoomLevel + 0.2, 2));
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoomLevel) => Math.max(prevZoomLevel - 0.2, 0.7));
  };

  const handleButtonStateChange = (newState: boolean) => {
    setButtonState(newState);
  };

  // if (exibirEmpreendimento === false) {
  //   return (
  //     <Styles.Container>
  //       <Header
  //         onClose={() => props?.onClose()}
  //         openOpportunityForm={props?.openOpportunityForm}
  //         onButtonStateChange={handleButtonStateChange}
  //       />
  //       <Styles.CenterText>
  //         Esse empreendimento não está disponível para consulta de vendas.
  //       </Styles.CenterText>
  //     </Styles.Container>
  //   );
  // }

  return (
    <Styles.Container>
      <Header
        onClose={() => props?.onClose()}
        openOpportunityForm={props?.openOpportunityForm}
        onButtonStateChange={handleButtonStateChange}
      />
      <ProductCard
        data={props?.data}
        dataResumo={dataEspelhoVenda?.data}
        blocosData={props?.data?.blocosData}
      />
      {dataEspelhoVenda?.data?.pavimentos?.length > 0 ? (
        <Espelho
          data={dataEspelhoVenda?.data?.pavimentos}
          headerData={props?.data}
          zoomLevel={zoomLevel}
          idLead={props?.idLead}
          buttonState={buttonState}
          dataResumo={dataEspelhoVenda?.data}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          width="96.5%"
          height="80vh"
          sx={{ borderRadius: "8px", margin: "20px" }}
        />
      )}

      <Footer onZoonIn={handleZoomIn} onZoonOut={handleZoomOut} />
    </Styles.Container>
  );
};

export default EspelhoVendasModal;
